<template>
  <div class="game-page">
    <v-header></v-header>
    <user-info :avatar="userAvatar" :user-name="userName"></user-info>
    <div class="select-content">
      <popup-selector
        @show-popup="popupShow('games')"
        :icon="curGame.PIC_URL || gameIcon"
        class="select-content_picker j-select-game-dcount"
      >
        <p class="selector-text selector-name j-select-game-dcount">遊戲</p>
        <p class="selector-text selector-value j-select-game-dcount">{{curGame.name || '請選擇遊戲'}}</p>
      </popup-selector>
      <popup-selector
        :icon="serverIcon"
        @show-popup="popupShow('servers')"
        class="select-content_picker j-select-server-dcount"
      >
        <p class="selector-text selector-name j-select-server-dcount">伺服器</p>
        <p
          class="selector-text selector-value j-select-server-dcount"
        >{{curServer.name || '請選擇伺服器'}}</p>
      </popup-selector>
      <popup-selector
        :icon="roleIcon"
        @show-popup="popupShow('roles')"
        class="select-content_picker j-select-role-dcount"
      >
        <p class="selector-text selector-name j-select-role-dcount">角色</p>
        <p class="selector-text selector-value j-select-role-dcount">{{curRole.name || '請選擇角色'}}</p>
      </popup-selector>
    </div>
    <div class="confirm-btn j-jump-next-dcount" @click="jumpToProducts">下一步</div>
    <popup-picker
      :list="list"
      v-if="pickerShow"
      :title="pickerTitle"
      @select="pickerSelect"
      @close="pickerShow = false"
    ></popup-picker>
  </div>
</template>

<script>
import gameIcon from '@/assets/game.png'
import roleIcon from '@/assets/role.png'
import vHeader from '@/components/header'
import serverIcon from '@/assets/server.png'
import userInfo from '@/components/user-info'
import popupPicker from '@/components/popup-picker'
import popupSelector from '@/components/popup-selector'
import { isEmptyObj, getHrefParamFromLocation as getHrefParam } from '@/utils'
export default {
  name: 'Game',
  components: { vHeader, userInfo, popupPicker, popupSelector },
  data () {
    return {
      gameIcon,
      roleIcon,
      serverIcon,
      userAvatar: '',
      userName: '',
      games: [],
      servers: [],
      roles: [],
      curGame: {},
      curServer: {},
      curRole: {},
      list: [],
      pickerShow: false,
      pickerType: '',
      pickerTitle: '',
      init: false,
      userInfo: {},
      lastPayInfo: {},
      initPicker: false
    }
  },
  watch: {
    curGame (data) {
      let allowGameId =
        process.env.NODE_ENV === 'development'
          ? [30, 38]
          : window.openPointsPayGames
      if (isEmptyObj(data)) {
        return
      }
      let needJump = allowGameId.indexOf(+data.ID) === -1
      if (needJump) {
        const cid = getHrefParam('cid') || '';
        const scid = getHrefParam('scid') || '';
        window.location.href = `//mstore.gm99.com/?gameId=${data.ID}&cid=${cid}&scid=${scid}`;
        return
      }
      this.curServer = {}
      this.servers = []
      this.curRole = {}
      this.roles = []
      this.fetchList('server', { game_id: data.ID })
    },
    curServer (data) {
      if (isEmptyObj(data)) {
        return
      }
      this.curRole = {}
      this.roles = []
      this.fetchList('role', { game_id: data.GAME_ID, server_id: data.ID })
    }
  },
  methods: {
    showTipsContent (content) {
      this.$store.commit('setTipsState', true)
      this.$store.commit('setTipsContent', content)
    },
    jumpToProducts () {
      if (!this.curGame.id) {
        this.popupShow('games')
        return
      }
      if (!this.curServer.id) {
        this.popupShow('servers')
        return
      }
      if (!this.curRole.id) {
        this.popupShow('roles')
        return
      }
      let userInfo = {
        game_id: this.curGame.id,
        game_name: this.curGame.name,
        server_id: this.curServer.ID,
        server_sid: this.curServer.SID,
        server_name: this.curServer.NAME,
        role_id: this.curRole.id,
        role_name: this.curRole.name,
        UID: this.userInfo.UID,
        account_name: this.userInfo.LOGIN_ACCOUNT,
        avatar: this.userInfo.AVATAR,
        wallet: this.userInfo.POINTS
      }
      window.gameId = this.curGame.id
      this.$store.commit('setUserInfo', userInfo)
      this.$router.push({ name: 'products' })
    },
    popupShow (type) {
      let title = {
        games: '請選擇遊戲',
        servers: '請選擇伺服器',
        roles: '請選擇角色'
      }
      this.init = true
      this.pickerType = type
      this.list = this[type]
      this.pickerTitle = title[type]
      this.pickerShow = true
    },
    pickerSelect (data) {
      if (this.pickerType === 'games') {
        this.curGame = data
      } else if (this.pickerType === 'servers') {
        this.curServer = data
      } else if (this.pickerType === 'roles') {
        this.curRole = data
      }
    },
    async fetchUserData () {
      return this.$jsonp('//mstore.gm99.com/points/pay_init_data')
        .then(res => {
          let data = res.data
          if (+res.result >= 1) {
            this.userInfo = data.user_info
            this.userName = data.user_info.LOGIN_ACCOUNT
            this.userAvatar = data.user_info.AVATAR
            if (data.last_pay_info) {
              this.lastPayInfo = data.last_pay_info
            } else if (data.last_play_info) {
              this.lastPayInfo = {
                PAY_GAME: data.last_play_info.GAME_ID,
                PAY_GAME_SERVER: data.last_play_info.SERVER_ID,
                ROLE_ID: data.last_play_info.ROLE_LIST[0]
                  ? data.last_play_info.ROLE_LIST[0].roleID
                  : ''
              }
            }
          } else {
            this.showTipsContent(res.msg)
          }
        })
        .catch(err => {
          this.showTipsContent(err.message || '系統錯誤')
        })
    },
    async fetchList (type, params) {
      let url = {
        game: '//mstore.gm99.com/ajax/game_list',
        server: '//mstore.gm99.com/ajax/server_list',
        role: '//mstore.gm99.com/ajax/get_user_role'
      }
      return this.$jsonp(url[type], params)
        .then(res => {
          let data = res.data
          if (+res.result >= 1) {
            this.initList(type, data)
            if (!this.initPicker) {
              this.initSelector(type)
            }
          } else {
            this.showTipsContent(res.msg)
          }
        })
        .catch(err => {
          this.showTipsContent(err.message || '系統錯誤')
        })
    },
    initList (type, data) {
      let types = {
        game: 'games',
        server: 'servers',
        role: 'roles'
      }
      let props = {
        role: 'roleName'
      }
      let ids = {
        role: 'roleID'
      }
      let hasProp = !!props[type]
      this[types[type]] = data.map(item => {
        if (item.PIC_URL) {
          item.icon = item.PIC_URL
        }
        if (hasProp) {
          item.id = item[ids[type]]
          item.name = item[props[type]]
        } else {
          item.id = item.ID
          item.name = item.NAME || item.REAL_NAME
        }
        return item
      })
    },
    initSelector (type) {
      let hasInfo = !!getHrefParam('gameId')
      let info = hasInfo
        ? {
          PAY_GAME: getHrefParam('gameId'),
          PAY_GAME_SERVER: getHrefParam('serverId'),
          ROLE_ID: getHrefParam('roleId')
        }
        : this.lastPayInfo
      let infoProps = {
        game: 'PAY_GAME',
        server: 'PAY_GAME_SERVER',
        role: 'ROLE_ID'
      }
      let itemProps = {
        game: 'ID',
        server: hasInfo ? 'SID' : 'ID',
        role: 'roleID'
      }
      let curProps = {
        game: 'curGame',
        server: 'curServer',
        role: 'curRole'
      }
      let index = this[`${type}s`].findIndex(
        item => item[itemProps[type]] === info[infoProps[type]]
      )
      this[curProps[type]] = index !== -1 ? this[`${type}s`][index] : {}
      if (index === -1 || type === 'role') {
        this.initPicker = true
        this.$nextTick(() => {
          this.$store.commit('setLoadingState', false)
        })
      }
    }
  },
  async created () {
    if (getHrefParam('gameId')) {
      window.gameId = getHrefParam('gameId')
    }
    // if (getHrefParam('packageName')) {
    //   window.sessionStorage.setItem('fromSDK', 1)
    // }
    await this.fetchUserData()
    await this.fetchList('game')
  }
}
</script>

<style lang="scss" scoped>
.game-page {
  overflow: auto;
  text-align: left;
  min-height: 100%;
  padding-bottom: 60px;
  box-sizing: border-box;
  background-color: #f4f4f4;
  .select-content {
    margin-top: 10px;
    padding: 15px 19px;
    box-sizing: border-box;
    background-color: #fff;
    &_picker {
      margin-top: 10px;
    }
    &_picker:first-of-type {
      margin-top: 0;
    }
  }
  .selector-text {
    margin: 0;
    padding: 0;
    line-height: 1.5\9;
  }
  .selector-name {
    font-size: 13px;
    color: #6d6d6d;
  }
  .selector-value {
    margin-top: 3px;
    font-size: 15px;
    font-weight: 700;
  }
  .confirm-btn {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    height: 50px;
    color: #fff;
    cursor: pointer;
    line-height: 50px;
    text-align: center;
    background-color: #e97d30;
  }
}
@media screen and (orientation: landscape) {
  .game-page {
    .select-content {
      margin-top: 0;
    }
  }
}
</style>
